// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .bg-primary {
    background-color: #007bff; 
}

.bg-primary-dark {
    background-color: #0056b3; 
}

.text-white {
    color: #fff;
}

.text-black {
    color: #000;
}

.rounded-l-lg {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}

.rounded-r-lg {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}

.hover\\\\:bg-primary:hover {
    background-color: #007bff;
}

.hover\\\\:bg-primary-dark:hover {
    background-color: #0056b3;
}

.hover\\\\:text-white:hover {
    color: #fff;
}

.transition {
    transition: all 0.3s ease;
} */

.custom-input-eng::placeholder {
    font-size: 15px; /* Adjust the font size as needed */
}

.custom-input::placeholder {
    font-size: 10px; /* Adjust the font size as needed */
}`, "",{"version":3,"sources":["webpack://./src/Components/searchbar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAwCG;;AAEH;IACI,eAAe,EAAE,mCAAmC;AACxD;;AAEA;IACI,eAAe,EAAE,mCAAmC;AACxD","sourcesContent":["/* .bg-primary {\n    background-color: #007bff; \n}\n\n.bg-primary-dark {\n    background-color: #0056b3; \n}\n\n.text-white {\n    color: #fff;\n}\n\n.text-black {\n    color: #000;\n}\n\n.rounded-l-lg {\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n\n.rounded-r-lg {\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.hover\\\\:bg-primary:hover {\n    background-color: #007bff;\n}\n\n.hover\\\\:bg-primary-dark:hover {\n    background-color: #0056b3;\n}\n\n.hover\\\\:text-white:hover {\n    color: #fff;\n}\n\n.transition {\n    transition: all 0.3s ease;\n} */\n\n.custom-input-eng::placeholder {\n    font-size: 15px; /* Adjust the font size as needed */\n}\n\n.custom-input::placeholder {\n    font-size: 10px; /* Adjust the font size as needed */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
